export const password = {
  setPassword: "Set Password",
  resetPassword: "@:password.setPassword",
  forgotPassword: "Forgot Password",
  sendEmailSuccessTips: "A verification code has been sent to {email}.",
  verificationCodeIsIncorrectTips: "The verification code is incorrect.",
  forgotPasswordEmailNotExistContent:
    "{email} not found. Please re-enter your account email and try again.",
  emailNotFundTips: "@:password.forgotPasswordEmailNotExistContent",
  resetPasswordSuccessContent:
    "Your password has been updated. Please sign in.",
  resetPasswordFailedContent: "@:password.setPasswordFailedContent",
  setPasswordFailedContent:
    "Failed to set password. Please contact the administrator of your VIA CWorkX Connect Cloud.",
  btnContinue: "Continue",
  email: "Email",
  company: "Company",
  verificationCode: "Verification Code",
  sendVerificationCode: "Send Verification Code",
  changePassword: "Change Password",
  oldPassword: "Old Password",
  newPassword: "New Password",
  confirmPassword: "Confirm Password",
  yourPasswordHasBeenUpdatedPleaseSignInAgain:
    "Your password has been updated. Please sign in again.",
  pleaseInputYourPassword: "Please input your password",
  mustContainBetweenMinToMaxCharacters:
    "Your password must contain between {min} and {max} characters",
  pleaseInputTheNewPassword: "Please input the new password",
  newPasswordAndYourOldPasswordAreTheSame:
    "New password and your old password are the same",
  pleaseInputTheNewPasswordAgain: "Please input the password again",
  theTwoNewPasswordsAreNotTheSame: "The two new passwords are not the same",
  savedSuccessfully: "Saved successfully.",
  userNotExist: "User not exist",
  oldPasswordIsIncorrect: "Old password is incorrect",
  failedToUpdatePassword: "Failed to update password",
  password: "Password",
  noSpaceAreAllowed: "No spaces are allowed",
  pleaseInputVerificationCode: "Please input verification code",
};
